import { Card } from 'react-bootstrap'
import React, { useCallback } from 'react'
import { Nav_Item } from './layout/interfaces'
import { useNavigate } from 'react-router-dom' // Import for navigation
import './HomeComponent.css'
import { notify } from './notify/notify'
import './beacon/styles/beacon.css'
import { apiFetch } from './utility/fetch'
import { CommonProperties } from './common/common.interfaces'

interface HomeComponentProps extends CommonProperties {
  navList: Nav_Item[]
}

const HomeComponent: React.FC<HomeComponentProps> = ({ navList, userData }) => {
  const roles = userData?.roles
  const userName = userData?.friendlyUserName
  const navigate = useNavigate() // React Router hook
  
  const sortedNavList = [...navList].sort((a, b) => a.displayName.localeCompare(b.displayName));

  const showHello = useCallback((e) => {
    const call = async function(){
      try {
        const response = await apiFetch({
          endpoint: 'salesforceQuery',
          method: 'POST',
          accessToken: userData.accessToken,
          body: JSON.stringify({
            soql: `SELECT Id FROM Account WHERE Name = 'Amazon US'`
          })
        })
        const body = response.body
        if(response.status === 200){
          notify('success', `Hello! Crystal Ball has secure api access 🙂 ! ${JSON.stringify(body)}`)
        } else {
          notify('error', `😔 ${JSON.stringify(body)}`)
        }
      }catch(error){
        console.log(error)
      }
    }
    call()
  }, [userData])

  return (
    <div className='home-main'>
      <div style={{textAlign: 'center'}}>
        <span className='home-label'> <span style={{cursor: 'pointer', fontWeight: 'lighter'}} onClick={showHello}>Hello!</span> Signed in as {userName}.</span>
      </div>
      <div className="app-grid">
        {roles && sortedNavList.map((item, index) => {
          const hasAccess = roles.some(role => item.userLevel.includes(role))
          const show = item.userLevel.length === 0 || hasAccess
          if (show) {
            return (
              <Card 
                key={index} 
                className="app-card" 
                onClick={() => navigate(item.link)} // Navigate on click
              >
                <Card.Header>
                  <Card.Title className="app-title">{item.displayName}</Card.Title>
                </Card.Header>
                <Card.Body><span className='app-label'>{item.description}</span></Card.Body>
              </Card>
            )
          }
          return null
        })}
      </div>

      {roles && roles.length === 0 && (
        <div className="no-access">
          An admin needs to update your roles to view this site. Please let them know you are waiting for access.
        </div>
      )}
    </div>
  )
}

export default HomeComponent